"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.insertMatchMaterial = exports.getFileUrlForSchool = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 * 描述 获取申报材料
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var getFileUrlForSchool = exports.getFileUrlForSchool = function getFileUrlForSchool(data) {
  return _api.default.request({
    url: '/matchMaterial/getFileUrlForSchool',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
/**
 * 描述 上传申报材料
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var insertMatchMaterial = exports.insertMatchMaterial = function insertMatchMaterial(data) {
  return _api.default.request({
    url: '/matchMaterial/insertMatchMaterial',
    method: 'post',
    data: data
  });
};